import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import "./index.css"

// Square configuration
const SQUARE_CONFIG = {
  applicationId: "sandbox-sq0idb-HkzTgNLPigKXUIabvXUaNQ", // Your sandbox application ID
  accessToken: "EAAAl9_w_a2Mv3FKvaICzB2Bdg-y-fR_noYnaLFtQq-7uUsblo-_IGYXJC12x_FI",
  locationId: "L9SCM63FS90GD"
}

// Load Square SDK script
const loadSquareSDK = () => {
  return new Promise((resolve, reject) => {
    if (window.Square) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://sandbox.web.squarecdn.com/v1/square.js";
    script.crossOrigin = "anonymous";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Square SDK"));
    document.head.appendChild(script);
  });
}

// Initialize Square payments
const initializeSquare = async () => {
  try {
    await loadSquareSDK();
    
    const payments = await window.Square.payments(
      SQUARE_CONFIG.applicationId,
      SQUARE_CONFIG.locationId
    );
    
    window.squarePayments = payments;
    console.log("Square SDK initialized successfully");
  } catch (error) {
    console.error("Square SDK initialization error:", error);
  }
}

// Initialize app after Square is loaded
const initializeApp = async () => {
  await initializeSquare();
  
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Start initialization when DOM is loaded
document.addEventListener("DOMContentLoaded", initializeApp);
